import React, {useState} from "react";
import ModalBox from "../../../Componnets/ModalBox/ModalBox";
import ImportFile from "./importBpmnModal/ImportFile";
import UploadProgress from "./importBpmnModal/UploadProgress";
import Rename from "./importBpmnModal/Rename";

const ImportBpmnModal = ({ showModal, handleTriggerShowModal, handleSetRefresh }) => {

  const [activeStepIndex, setActiveStepIndex] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState(null);

  const handleSetSelectedFile = (file) => {
    setSelectedFile(file)
  }

  const handleStepSubmit = (filename = null) => {
    setActiveStepIndex(activeStepIndex + 1);
    if(filename.replace(/ /g,'') !== '') {
      setFileName(filename);
    }
  }

  const handlePreviousStep = () => {
    if (activeStepIndex > 0) {
      setActiveStepIndex(activeStepIndex - 1);
    }
  }

  const handleOnClose = () => {
    setSelectedFile(null);
    setActiveStepIndex(0);
    handleTriggerShowModal();
  }

  return (
    <ModalBox
      title={'BPMN Import'}
      size={'small'}
      showModal={showModal}
      handleTriggerShowModal={handleOnClose}
      handleOnPrevious={(file) => handlePreviousStep(file)}
    >
      {
        activeStepIndex === 0 && <ImportFile
          onSubmit={handleStepSubmit}
          handleSetSelectedFile={handleSetSelectedFile}
        />
      }
      {
        activeStepIndex === 1 && <Rename
          onSave={handleStepSubmit}
          fileName={fileName}
        />
      }
      {
        activeStepIndex === 2 && <UploadProgress
          handleSetRefresh={handleSetRefresh}
          handlePreviousStep={handlePreviousStep}
          selectedFile={selectedFile}
          handleTriggerShowModal={handleOnClose}
          fileName={fileName}
        />
      }

    </ModalBox>
  )
};

export default ImportBpmnModal;